import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import './classes/AgencyNewsContent.css';
import './classes/SmwwBlogPost.css';
import { keepLiveLinksOnSite } from "./liveSiteLinks";

const LIVE_IMAGES = "https://www.sportsmanagementworldwide.com/images/";
const SHARE_LINKS = [
    { url: "https://www.facebook.com/sharer.php?u=", icon: "fb_blog_red.png" },
    { url: "https://www.linkedin.com/shareArticle?url=", icon: "linkedin_blog_red.png" },
    { url: "https://twitter.com/intent/tweet?url=", icon: "twitter_blog_red.png" },
];

// The Constant Contact sign-up form in each post's sidebar ("Newsletter Signup"). The widget
// fills the .ctct-inline-form boxes on the page when its script runs, and only runs once a page
// (it stops when window.SignUpFormWidget exists), so the script is run afresh whenever new
// posts are shown.
const CTCT_ACCOUNT = "5920d12f1e468ce89e7a7fb90bde991b";
const CTCT_FORM_ID = "f5374e08-04d4-4b8f-ba19-4cf4f3482b4d";
export const useConstantContactForms = (shownPosts) => {
    useEffect(() => {
        if (!document.querySelector(".ctct-inline-form:empty")) return;
        window._ctct_m = CTCT_ACCOUNT;
        document.getElementById("signupScript")?.remove();
        delete window.SignUpFormWidget;
        const script = document.createElement("script");
        script.id = "signupScript";
        script.src = "https://static.ctctcdn.com/js/signup-form-widget/current/signup-form-widget.min.js";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }, [shownPosts]);
};

// One blog post as the live site's node--blog.tpl.php shows it: banner, title with date and
// author, share icons beside the body, a sidebar with the recent posts and the newsletter
// form, and a share row with a Back button under it. In a list (Blog Home) the post's title
// comes first, linked to the post. Links in the body typed with the live site's domain (the
// course links) stay on this site.
const SmwwBlogPost = ({ post, recentPosts, inList }) => {
    const shareUrl = window.location.href;
    const shareIcons = (lineBreaks) => SHARE_LINKS.map((share) => (
        <React.Fragment key={share.icon}>
            <a target="_blank" rel="noopener noreferrer" href={share.url + shareUrl}><img src={LIVE_IMAGES + share.icon} alt="" /></a>
            {lineBreaks ? <><br /><br /></> : ' '}
        </React.Fragment>
    ));

    return (
        <div id={"node-" + post.id} className={"node node-blog node-promoted smww-blog-node" + (inList ? " node-teaser" : "")}>
            {inList && <h2><a href={post.link}>{post.title}</a></h2>}
            <div className="content clearfix">
                <div className="container smw-st-blog">
                    <header className="hero">
                        <img src={post.banner} alt="" style={{ margin: "0 auto", display: "block" }} />
                        <div className="headline-wrapper">
                            <h2 className="subheadline"></h2>{/* eslint-disable-line jsx-a11y/heading-has-content */}
                        </div>
                    </header>
                </div>

                <div className="container ds smw-st-blog">
                    <div className="row">
                        <div className="col-md-9">
                            <h1 className="my-4">{post.title}
                                <br />
                                <small>{post.date}
                                    {post.author && (
                                        <> by <span className="author">{post.author_link ? (
                                            <a style={{ color: "#99d888" }} target="_blank" rel="noopener noreferrer" href={post.author_link}>{post.author}</a>
                                        ) : (
                                            <span style={{ color: "#99d888" }}>{post.author}</span>
                                        )}</span></>
                                    )}
                                </small>
                            </h1>
                            <div className="blog_body_details">
                                <div className="column1">
                                    <span style={{ color: "#003c7d" }}><b>SHARE</b></span><br /><br />
                                    {shareIcons(true)}
                                </div>
                                <div className="column2" dangerouslySetInnerHTML={{ __html: keepLiveLinksOnSite(post.body) }} />
                            </div>
                            <div style={{ clear: "both" }}></div>
                        </div>

                        <div className="col-md-3 gs">
                            <div className="card my-4 ms-bg-bl des-bord">
                                <h5 className="card-header post-sidebar-heading">Recent Posts</h5>
                                <hr />
                                <ul className="list-unstyled mb-0">
                                    {recentPosts.map((recent) => (
                                        <React.Fragment key={recent.link}>
                                            <li style={{ listStyleType: "none" }}>
                                                <a href={recent.link}><img src={recent.img} alt="" />
                                                    <p className="stwwt-post-title">{recent.title}</p></a>
                                            </li>
                                            <hr />
                                        </React.Fragment>
                                    ))}
                                </ul>
                            </div>
                            <div className="card my-4 ms-bg-bl bg-sta-wrapper">
                                <h5 className="card-header post-sidebar-heading">Newsletter Signup</h5>
                                <hr />
                                <div className="newsletter_wrapper">
                                    <div className="ctct-inline-form" data-form-id={CTCT_FORM_ID}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div style={{ clear: "both" }}></div>
                <div className="social-share container ds smw-st-blog">
                    <div className="row">
                        <div className="column1">
                            <span style={{ color: "#003c7d", fontSize: "15px" }}><b>SHARE</b></span>
                        </div>
                        <div className="column2">{shareIcons(false)}</div>
                        <div className="column3">
                            <a href="/smww-blog"><button id="back_button" className="button mr-1 arrow" type="button">Back</button></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// A post at its own address (e.g. /content/<slug> for posts copied from Drupal), which Page.js
// shows when no page has that address. Admins get the View / Edit tabs of a node page.
export const SmwwBlogPostPage = ({ post, recentPosts, isAdmin }) => {
    useConstantContactForms(post.id);
    return (
        <div id="main" className="smww-blog-page node-type-blog">
            {/* As on the live site, the tab shows the post's meta title where it has one, and the head
                has its meta description and keywords: the same as the server put in the page's HTML
                (the backend's SharePreview), which would otherwise go when this replaces it */}
            <Helmet>
                <title>{post.meta_title || post.title}</title>
                {post.meta_description && <meta name="description" content={post.meta_description} />}
                {post.meta_keywords && <meta name="keywords" content={post.meta_keywords} />}
            </Helmet>
            <div className="left"></div>
            <div className="center left-center">
                {/* Live's page template heads a post with its title alone, which the post's styles hide
                    (SmwwBlogPost.css): the page's first heading is the title, not the date and author */}
                <h1 className="page-content-title">{post.title}</h1>
                {isAdmin && (
                    <ul className="tabs primarya">
                        <li className="active"><a href={post.link}>View</a></li>
                        <li><a href={"/blog-content/" + post.id + "/edit"}>Edit</a></li>
                    </ul>
                )}
                <SmwwBlogPost post={post} recentPosts={recentPosts} />
            </div>
            <div className="right"></div>
        </div>
    );
};

export default SmwwBlogPost;
